import MDEditor from '@uiw/react-md-editor';
import '../styles/RichMarkdown.css';

/**
 * RichMarkdown component that renders both markdown AND inline HTML
 * Useful for descriptions with mixed markdown + HTML styling
 */
function RichMarkdown({ source }) {
  if (!source) return null;

  // Check if content contains HTML tags
  const hasHtml = /<[a-z][\s\S]*>/i.test(source);

  if (hasHtml) {
    // Render as HTML-aware markdown
    return (
      <div className="rich-markdown" dangerouslySetInnerHTML={{ __html: source }} />
    );
  }

  // Regular markdown
  return <MDEditor.Markdown source={source} />;
}

export default RichMarkdown;
